import * as React from "react";
import TextAction, { TextActionProps } from "./TextAction";

export default function EditAction(props: TextActionProps) {
  return <TextAction
    {...props} icon={<i className="ic_edit" />} label={props.label || i18n["Global.Edit"]} />;
}
